<template>
  <div v-tooltip="presentation.privateMode ? publicModeTooltip : privateModeTooltip">
    <li class="sidebar-item pointer" @click.stop="isModalPrivateModeVisile = true">
      <a class="sidebar-link waves-effect waves-dark sidebar-link-custom">
        <span
          v-if="presentation.privateMode"
          class="whitespace-normal horizontal layout start"
        >
          <aha-icon
            width="22"
            class="sidebar-link-icon mt-1"
            name="lockv2"
            viewBox="0 0 16 16"
          ></aha-icon>
          <span class="hide-menu nav-left-text pt-0.5">
            {{ $t('Private') }}
            <br>
            <span class="text-sm">{{ $t('Switch to public') }}</span>
          </span>
        </span>
        <span
          v-if="!presentation.privateMode"
          class="whitespace-normal horizontal layout start"
        >
          <aha-icon
            width="22"
            class="sidebar-link-icon mt-1"
            name="icon-multiple-language"
            viewBox="0 0 17 18"
          ></aha-icon>
          <span class="hide-menu nav-left-text pt-3px">
            {{ $t('Public') }}
            <br>
            <span class="text-sm">{{ $t('Switch to private') }}</span>
          </span>
        </span>
      </a>
    </li>
    <ModalPresentingPrivateMode
      @hideModal="isModalPrivateModeVisile = false"
      v-if="isModalPrivateModeVisile"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import ModalPresentingPrivateMode from '@/components-v2/modals/PresentingPrivateMode.vue'

export default {
  components: {
    ModalPresentingPrivateMode,
  },
  data: () => ({
    isModalPrivateModeVisile: false,
  }),
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    publicModeTooltip() {
      return this.$i18nPresenter.t('Public: Audience can see and interact with your slides')
    },
    privateModeTooltip() {
      return this.$i18nPresenter.t('Private: Audience cannot see or interact with your slides')
    },
  },
}
</script>

<style  lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.sidebar-item {
  width: unset;
  .sidebar-link {
    padding: 9px 15px 9px 12px !important;
    &.sidebar-link-custom {
      white-space: normal;
    }
    &:hover {
      .fas, .far {
        color: $primary-color;
      }
    }
    .sidebar-link-icon {
      font-size: 20px;
      margin-right:12px;
    }
  }
  .active {
    background-color: rgba(0, 0, 0, 0.07);
  }
  .nav-left-text {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    font-size: 16px;
  }
}
</style>
